import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import Userlist from './userlist';

function Usercontroller() {
    return[
     
        
        <Topnavbar />,
      
        <Sidennav />,
        <Userlist />,
    ];
    
}

export default Usercontroller;